import { listItem } from './ListItem.css';
import type { PostListItemProps } from './ListItem.types';

export const PostListItem = ({ element, children, ...props }: PostListItemProps) => {
  return (
    <li {...props} className={listItem}>
      {children}
    </li>
  );
};
